import { render, staticRenderFns } from "./option-item.vue?vue&type=template&id=5535044a&scoped=true"
import script from "./option-item.vue?vue&type=script&lang=js"
export * from "./option-item.vue?vue&type=script&lang=js"
import style0 from "./option-item.vue?vue&type=style&index=0&id=5535044a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5535044a",
  null
  
)

export default component.exports